import React from 'react';
import { TrendingUpIcon, UsersIcon, ListTodoIcon, CheckSquareIcon, ClockIcon, BarChart3Icon } from 'lucide-react';
export const WorkspaceMetrics = () => {
  const metrics = [{
    title: 'Team Engagement',
    value: '82%',
    change: '+12%',
    icon: <UsersIcon size={18} className="text-blue-500" data-id="element-153" />,
    color: 'bg-blue-50'
  }, {
    title: 'Actions Completed',
    value: '24',
    change: '+8',
    icon: <CheckSquareIcon size={18} className="text-green-500" data-id="element-154" />,
    color: 'bg-green-50'
  }, {
    title: 'Avg. Response Time',
    value: '3.2h',
    change: '-0.8h',
    icon: <ClockIcon size={18} className="text-purple-500" data-id="element-155" />,
    color: 'bg-purple-50'
  }];
  return <>
      {metrics.map((metric, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-156">
          <div className="flex items-center justify-between mb-3" data-id="element-157">
            <div className={`w-10 h-10 rounded-full ${metric.color} flex items-center justify-center`} data-id="element-158">
              {metric.icon}
            </div>
            <div className="flex items-center gap-1 text-green-500 text-sm font-medium" data-id="element-159">
              <TrendingUpIcon size={14} data-id="element-160" />
              {metric.change}
            </div>
          </div>
          <h3 className="text-gray-500 text-sm mb-1" data-id="element-161">{metric.title}</h3>
          <p className="text-2xl font-bold text-gray-800" data-id="element-162">{metric.value}</p>
        </div>)}
    </>;
};